import { MenuItem, RadioGroup, Select } from '@mui/material'
import {
  OptionsBaseContainer,
  OptionsRow,
  RadioButton,
  RadioFormControlLabel,
} from './RecurrenceOptions.styled'
import {
  dayOfTheMonthSelectOptions,
  TimeUnitSubTypeEnum,
  OnUpdateOptions,
  RecurrenceOptions,
  dayOfTheWeekSelectOptions,
  weekOfMonthSelectOptions,
} from '../types'

export type MonthlyOptionsProps = {
  dayOfMonth: RecurrenceOptions['dayOfMonth']
  timeUnitSubType: TimeUnitSubTypeEnum
  onUpdateOptions: OnUpdateOptions
  weekOfMonth: RecurrenceOptions['weekOfMonth']
  dayOfWeek: RecurrenceOptions['dayOfWeek']
}

export const MonthlyOptions = ({
  dayOfMonth,
  timeUnitSubType,
  onUpdateOptions,
  weekOfMonth,
  dayOfWeek,
}: MonthlyOptionsProps) => (
  <OptionsBaseContainer>
    <RadioGroup
      name='task-modal-v2-monthly-date-radio-group'
      onChange={({ target }) =>
        onUpdateOptions({
          key: 'timeUnitSubType',
          value: target.value as TimeUnitSubTypeEnum,
        })
      }
      value={timeUnitSubType}
      sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
    >
      <OptionsRow>
        <RadioFormControlLabel
          value={TimeUnitSubTypeEnum.dayOfMonth}
          control={<RadioButton />}
          label='on'
        />
        <Select
          disabled={timeUnitSubType === TimeUnitSubTypeEnum.dayOfWeek}
          id='task-modal-v2-monthly-on-day-select'
          labelId='task-modal-v2-monthly-on-day-select-label'
          onChange={({ target }) =>
            onUpdateOptions({
              key: 'dayOfMonth',
              value: target.value as RecurrenceOptions['dayOfMonth'],
            })
          }
          sx={{ width: '100%' }}
          value={dayOfMonth}
        >
          {dayOfTheMonthSelectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </OptionsRow>
      <OptionsRow>
        <RadioFormControlLabel
          value={TimeUnitSubTypeEnum.dayOfWeek}
          control={<RadioButton />}
          label='on the'
        />
        <Select
          disabled={timeUnitSubType === TimeUnitSubTypeEnum.dayOfMonth}
          id='task-modal-v2-monthly-on-weekly-interval-select'
          labelId='task-modal-v2-monthly-on-weekly-interval-select-label'
          onChange={({ target }) =>
            onUpdateOptions({
              key: 'weekOfMonth',
              value: target.value as RecurrenceOptions['weekOfMonth'],
            })
          }
          sx={{ width: '100%' }}
          value={weekOfMonth}
        >
          {weekOfMonthSelectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        <Select
          disabled={timeUnitSubType === TimeUnitSubTypeEnum.dayOfMonth}
          id='task-modal-v2-monthly-on-weekly-interval-day-select'
          labelId='task-modal-v2-monthly-on-weekly-interval-day-select-label'
          onChange={({ target }) =>
            onUpdateOptions({
              key: 'dayOfWeek',
              value: target.value as RecurrenceOptions['dayOfWeek'],
            })
          }
          sx={{ width: '100%' }}
          value={dayOfWeek}
        >
          {dayOfTheWeekSelectOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </OptionsRow>
    </RadioGroup>
  </OptionsBaseContainer>
)
